import React from 'react';
import AntConfigProvider from 'antd-core/es/config-provider';
import { StyleProvider } from '@ant-design/cssinjs';
import { createAntdTheme } from './utils.js';
import { Language } from '../locale/Language.js';
import { SamoletTheme } from './SamoletTheme.js';
import { ConfigProvider } from './ConfigProvider.js';
import { Theme } from './Theme.js';

const TendUI = ({ lang = 'ru', theme = 'samolet', children, }) => {
    return (React.createElement(StyleProvider, { hashPriority: 'high' },
        React.createElement(Theme, { theme: theme },
            React.createElement(Language, { language: lang },
                React.createElement(ConfigProvider, null, children)))));
};
TendUI.init = (theme = SamoletTheme) => {
    AntConfigProvider.config({
        prefixCls: 'tend-ui',
        theme: createAntdTheme(theme),
    });
};

export { TendUI };
//# sourceMappingURL=TendUI.js.map
